var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Appearance Page")]),_c('router-link',{attrs:{"to":"/configure/user/settings"}},[_vm._v("Other Settings")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }